import { Grid, Stack, Typography } from '@mui/material';
import React from 'react';

const EstimateTermsAndWarranty = ({ estimateData = {} }) => {
    return (
        <Grid container item justifyContent={'start'}>
            <Grid item>
                <Stack spacing={1} style={{ marginRight: '24px' }}>
                    <Typography fontWeight={500}>Terms and Conditions</Typography>
                    <Typography
                        variant="body1"
                        fontWeight={400}
                        fontSize={16}
                        whiteSpace="pre-line"
                        style={{ color: 'rgba(0, 0, 0, 0.65)', wordBreak: 'break-word' }}
                    >
                        {estimateData?.termsAndWarranty?.title}
                    </Typography>
                    <Typography
                        variant="body1"
                        fontWeight={400}
                        fontSize={16}
                        whiteSpace="pre-line"
                        style={{ color: 'rgba(0, 0, 0, 0.65)', wordBreak: 'break-word' }}
                    >
                        {estimateData?.termsAndWarranty?.description}
                    </Typography>
                </Stack>
            </Grid>
        </Grid>
    );
};

export default EstimateTermsAndWarranty;
